<div class="dialog-content-wrapper" style="margin: -24px;">
    <mat-toolbar matDialogTitle class="mat-indigo-800-bg m-0 customBlue">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title dialog-title">{{translations.lblMappingForm}}</span>
            <button mat-button class="mat-icon-button" (click)="dialogRef.close()" aria-label="Close dialog">
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>

    <div mat-dialog-content class="p-24 m-0" fusePerfectScrollbar style="padding-bottom:0px !important;">
        <form [formGroup]="formGroup" class="user-actions" novalidate>
            <section class="example-section">
                <div class="languages" *ngFor="let record of rmList; let i = index;">
                    <mat-form-field class="mr-24"  fxFlex.xs="100" fxFlex="100">
                        <input matInput [(ngModel)]="record.Value" maxlength="25" [ngModelOptions]="{standalone: true}" disabled>
                    </mat-form-field>
                    <mat-form-field class="mr-24"  fxFlex.xs="100" fxFlex="100">
                        <input matInput placeholder="{{translations.txtCode}}" [(ngModel)]="record.Code" maxlength="25" [ngModelOptions]="{standalone: true}">
                    </mat-form-field>
                    <mat-form-field class="mr-24"  fxFlex.xs="100" fxFlex="100">
                        <input matInput placeholder="{{translations.txtDescription}}" [(ngModel)]="record.Description" maxlength="100" [ngModelOptions]="{standalone: true}">
                    </mat-form-field> 
                </div>
            </section>  
        </form>
    </div>
    <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="left">
        <button mat-raised-button color="accent" aria-label="SAVE" (click)="save();" fxFlex="47">
            {{translations.btnSave}}
        </button>
        <button mat-raised-button color="warn" aria-label="CLOSE" mat-dialog-close fxFlex="47">
            {{translations.btnClose}}
        </button>
    </div>
</div>     


// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/components/general/language-edit-form/language-edit-form.component.html